
import React from 'react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

type BeltType = 'white' | 'yellow' | 'orange' | 'light-blue' | 'green' | 'purple' | 'brown' | 'red' | 'navy' | 'grey' | 'black' | 'black-white' | 'dragon' | 'weapon';

interface BeltIconProps {
  type: BeltType;
  size?: number;
  className?: string;
  responsive?: boolean;
}

const getBeltImagePath = (type: BeltType): string => {
  // Handle special cases
  if (type === 'dragon') {
    return '/images/icons/lil_dragon_no_text_close.png';
  }
  
  if (type === 'weapon') {
    // We'll choose one weapon icon as default - we can modify this later if needed
    const weapons = ['bo', 'escrima', 'katana', 'nunchaka'];
    const randomIndex = Math.floor(Math.random() * weapons.length);
    return `/images/icons/${weapons[randomIndex]}.png`;
  }
  
  // Regular belts
  return `/images/belts/${type}_belt.png`;
};

export const BeltIcon: React.FC<BeltIconProps> = ({ type, size, className, responsive = true }) => {
  const isMobile = useIsMobile();
  const defaultSize = responsive && isMobile ? 25 : 30;
  const finalSize = size || defaultSize;
  const imagePath = getBeltImagePath(type);
  
  return (
    <div 
      className={cn(
        responsive ? 'w-[25px] h-[25px] md:w-[30px] md:h-[30px]' : `w-[${finalSize}px] h-[${finalSize}px]`,
        'relative flex items-center justify-center',
        className
      )}
      title={type.replace('-', ' ')}
    >
      <img 
        src={imagePath} 
        alt={`${type} belt`} 
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default BeltIcon;
